const SharedVisualLayers = Object.freeze({
    PLANET_NAMES: 4,
    EARTH_NAME: 1,
    OBJECT_NAMES: 2,
    MAGNITUDE_LABELS: 3,
});

const Layers = {
    COMMON: {
        DEFAULT: 0,
        WATERMARKS: 0,
    },
    VIS: SharedVisualLayers,
    OVT: SharedVisualLayers,
    SOVT: SharedVisualLayers,
    FVT: SharedVisualLayers,
    SCD: {
        OBJECT_NAMES: 1,
        TRACK_DESCRIPTION: 2,
        CONSTELLATIONS: 3,
        DSOS: 4,
        PLANET_NAMES: 5,
        PLANETS: 6,
        MOON_NAME: 7,
        MOON: 8,
    },
};

export default Layers;

